import React from 'react'
import { withStyles, createStyles } from '@mui/styles'
import { Paper, Typography } from '@mui/material'
import { muiOptions, MuiProps, defaultStyles, defaultColors } from '../../infrastructure/materialUiThemeProvider'
import { t } from '../../infrastructure/i18nextHelper'
import { Button, DataTable } from '../common/customComponents'
import { StockProjection } from './stockModels'
import { navigateTo } from '../../infrastructure/navigation'
import { projectionColumnStyles, useProjectionColumns } from './projectionColumns'
import { hasFeature } from '../../infrastructure/feature'

function _StockProjectionTable({ classes, className }: MuiProps & { className?: string }) {
    let { columns: stockProjectionColumns, store, stockFiltersStore } = useProjectionColumns(classes)
    let openActualStockEditionPopup = () => store.setShowActualStockDisplay(true)
    let openActualStockCreationPopup = () => openActualStockEditionPopup()
    let StockProjectionDataTable = DataTable as React.ComponentType<any>
    return (
        <Paper data-tour={'stockProjectionTable'} className={classes.stockTable + (className ? ' ' + className : '')}>
            <div className={classes.rowStockTableHeader}>
                <div className={classes.tableHeaderRow}>
                    <Typography className={classes.paperTitle} variant='overline' display='block' gutterBottom>
                        {t('stock.stockTable.' + (stockFiltersStore.filters.usefulStock ? 'usefulStockTitle' : 'title'), { unit: store.unit })}
                    </Typography>
                </div>
                <div>
                    {hasFeature('Simulation') &&
                        <Button label={t('stock.label.simulationButton')}
                            onClick={() => navigateTo('/simulation')}
                            className={classes.secondaryButton} />}
                    <Button tourKey='stockProjectionTableActualVolumesButton'
                        label={t('stock.label.enterActualStocksButton')}
                        onClick={openActualStockCreationPopup}
                        className={classes.secondaryButton} />
                </div>
            </div>
            <div className={classes.stockTableDiv} >
                {React.createElement(StockProjectionDataTable, {
                    isSelectable: false,
                    idSelector: (x: StockProjection) => x.date,
                    items: store.stockProjectionResult.values ? store.stockProjectionResult.values : [],
                    columns: stockProjectionColumns
                })}
            </div>
        </Paper>
    )
}

let styles = _ =>
    createStyles({
        ...projectionColumnStyles,
        stockTable: {
            height: '100%',
            width: '100%',
            display: 'flex',
            flexDirection: 'column'
        },
        stockTableDiv: {
            height: '100%',
            width: '100%',
            overflowY: 'auto',
            overflowX: 'hidden'
        },
        row: {
            ...defaultStyles.flexRow,
            alignItems: 'stretch',
            justifyContent: 'space-between',
            margin: '0.2em 1em',
            height: '3.2em'
        },
        rowStockTableHeader: {
            ...defaultStyles.flexRow,
            alignItems: 'center',
            justifyContent: 'space-between',
            margin: '0.2em 1em'
        },
        tableHeaderRow: {
            ...defaultStyles.flexRow,
            margin: '0.4em 0'
        },
        paperTitle: {
            color: defaultColors.red.main.color,
            marginBottom: '0'
        },
        secondaryButton: {
            ...defaultStyles.secondaryButton,
            marginLeft: '1em'
        },
    })

export let StockProjectionTable = withStyles(styles, muiOptions)(_StockProjectionTable)
